import { render, staticRenderFns } from "./doc_detail.vue?vue&type=template&id=90536fcc&scoped=true"
import script from "./doc_detail.vue?vue&type=script&lang=js"
export * from "./doc_detail.vue?vue&type=script&lang=js"
import style0 from "./doc_detail.vue?vue&type=style&index=0&id=90536fcc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90536fcc",
  null
  
)

export default component.exports